import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'

export const SEQUENCE_COLUMNS: Record<string, DataTypeColumn> = {
  seq_membership_status: {
    // "Sequence Status", not bare "Status": the header must visibly pair with
    // the "Sequence Status" filter (FIR-7974 — bare "Status" left users
    // guessing which filter drives this column).
    header: 'Sequence Status',
    group: 'Sequencing',
  },
  seq_scheduled_emails: {
    header: 'Scheduled Emails',
    group: 'Sequencing',
  },
  seq_emails_sent: {
    header: 'Sent',
    group: 'Sequencing',
  },
  seq_replies: {
    header: 'Replies',
    group: 'Sequencing',
  },
  seq_last_email: {
    header: 'Last Email',
    group: 'Sequencing',
  },
  seq_sequence_step: {
    header: 'Sequence Step',
    group: 'Sequencing',
  },
}

export const SEQUENCE_SORTABLE_FIELDS = [
  'seq_emails_sent',
  'seq_last_email',
  'seq_membership_status',
  'seq_scheduled_emails',
  'seq_replies',
]
